import React from 'react';
import { Advice } from '@Sage/hoi-poi-ui';
function Message(_ref) {
  let {
    placeholder,
    messageType = 'info',
    showCollapse = false,
    showIcon = false,
    defaultCollapsed = false,
    title = null
  } = _ref;
  return /*#__PURE__*/React.createElement(Advice, {
    showIcon: showIcon,
    type: messageType,
    showCollapse: showCollapse,
    defaultCollapsed: defaultCollapsed,
    title: title
  }, placeholder);
}
export default Message;